import { Appointment } from '../state/appointment';

export const getScheduleIdForAppointment = (appointment: Appointment): string => {
  return appointment
    .supportingInformation!.filter((i: any) => i.scheduleId || i.reference?.startsWith('Schedule/'))
    .map((i: any) => i.scheduleId || i.reference!.slice(9))
    .find((s: any) => s);
};
